import useUserPermission from "~/hooks/useUserPermission";
import { MANAGE_PROJECTS } from "~/router/permissions";

export const useCanManageProjects = (): boolean => useUserPermission(MANAGE_PROJECTS);
